import React from "react";
import { Box, keyframes } from "@mui/material";

// Keyframes for the animated icon
const slideInLeft = keyframes`
  0% { transform: translate(-200%, 100%) rotate(-20deg); opacity: 0; }
  100% { transform: translate(-20px, 10px) rotate(-5deg); opacity: 1; }
`;

const slideInRight = keyframes`
  0% { transform: translate(200%, 100%) rotate(20deg); opacity: 0; }
  100% { transform: translate(20px, 10px) rotate(5deg); opacity: 1; }
`;

const slideInCenter = keyframes`
  0% { transform: translate(0, 200%) scale(0.5); opacity: 0; }
  100% { transform: translate(0, 0) scale(1); opacity: 1; }
`;

const pulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 168, 150, 0.4); }
  70% { transform: scale(1.05); box-shadow: 0 0 0 20px rgba(0, 168, 150, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 168, 150, 0); }
`;

const PaperDoc = ({ animation, delay, style }) => (
    <Box
        sx={{
            width: 70, // Scaled down for icon use (original 140)
            height: 90, // Scaled down (original 180)
            bgcolor: "background.paper",
            borderRadius: 1.5,
            boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            p: 1.25,
            gap: 0.75,
            animation: animation ? `${animation} 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards` : 'none',
            animationDelay: `${delay}s`,
            opacity: animation ? 0 : 1, // Visible if no animation
            border: "1px solid",
            borderColor: "divider",
            ...style,
        }}
    >
        {/* Header Line */}
        <Box sx={{ width: "40%", height: 5, bgcolor: "primary.main", borderRadius: 2.5, mb: 0.5 }} />

        {/* Body Lines */}
        <Box sx={{ width: "100%", height: 3, bgcolor: "action.hover", borderRadius: 1.5 }} />
        <Box sx={{ width: "90%", height: 3, bgcolor: "action.hover", borderRadius: 1.5 }} />
        <Box sx={{ width: "95%", height: 3, bgcolor: "action.hover", borderRadius: 1.5 }} />

        {/* Accent Line */}
        <Box sx={{ width: "60%", height: 3, bgcolor: "primary.light", borderRadius: 1.5, opacity: 0.3, mt: 0.5 }} />

        {/* More Body Lines */}
        <Box sx={{ width: "85%", height: 3, bgcolor: "action.hover", borderRadius: 1.5 }} />
        <Box sx={{ width: "90%", height: 3, bgcolor: "action.hover", borderRadius: 1.5 }} />
    </Box>
);

const AnimatedDocIcon = ({ animate = false, size = 1 }) => {
    return (
        <Box sx={{ position: "relative", width: 150 * size, height: 150 * size, display: "flex", alignItems: "center", justifyContent: "center" }}>
            {/* Background Circle */}
            <Box
                sx={{
                    position: "absolute",
                    width: 140 * size,
                    height: 140 * size,
                    borderRadius: "50%",
                    bgcolor: "primary.main",
                    opacity: 0.05,
                    animation: animate ? `${pulse} 2s infinite` : 'none',
                    transform: animate ? 'scale(1)' : 'scale(0.8)',
                    transition: 'transform 0.3s ease'
                }}
            />

            {/* Left Paper */}
            <PaperDoc
                animation={animate ? slideInLeft : null}
                delay={0.1}
                style={{ zIndex: 1, transform: animate ? undefined : 'translate(-10px, 5px) rotate(-10deg) scale(0.9)' }}
            />

            {/* Right Paper */}
            <PaperDoc
                animation={animate ? slideInRight : null}
                delay={0.3}
                style={{ zIndex: 2, transform: animate ? undefined : 'translate(10px, 5px) rotate(10deg) scale(0.9)' }}
            />

            {/* Center Paper (Main) */}
            <PaperDoc
                animation={animate ? slideInCenter : null}
                delay={0.6}
                style={{ zIndex: 3, transform: animate ? undefined : 'translate(0, 0) scale(1)' }}
            />
        </Box>
    );
};

export default AnimatedDocIcon;
